import { PipeTransform } from '@angular/core';
import { FuseUtils } from '@fuse/utils';
var MaxLengthPipe = /** @class */ (function () {
    function MaxLengthPipe() {
    }
    MaxLengthPipe.prototype.transform = function (value, length) {
        return value.length > length ? FuseUtils.stringTruncade({ value: value, length: length }) : value;
    };
    return MaxLengthPipe;
}());
export { MaxLengthPipe };
